import { useWizard } from '../../../context/WizardContext';
import { ExamTypeSelector } from '../../../components/wizard/ExamTypeSelector';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';

export function Step4ExamType() {
  const { state, setExamType } = useWizard();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select Exam Type</h2>
        <p className="text-sm text-slate-500 mt-1">
          What kind of questions do you want to generate?
        </p>
      </div>
      <ExamTypeSelector value={state.selectedExamType} onChange={setExamType} />
      <NavigationButtons />
    </div>
  );
}
